import { DeviceName } from 'types/models';

import { axiosRequest } from '../axios';

export const ManualControlUrls = {
  GetCurrentMainOperator: {
    method: 'get',
    url: (deviceName: DeviceName) => `ManualControl/GetCurrentMainOperator/${deviceName}`,
  },
  SetCurrentActivity: {
    method: 'post',
    url: (deviceName: DeviceName) => `ManualControl/SetCurrentActivity/${deviceName}`,
  },
  RemoveCurrentActivity: {
    method: 'delete',
    url: (deviceName: DeviceName) => `ManualControl/RemoveCurrentActivity/${deviceName}`,
  },
  PingActivity: {
    method: 'post',
    url: (deviceName: DeviceName) => `ManualControl/PingActivity/${deviceName}`,
  },
  RequestControlPermission: {
    method: 'post',
    url: (deviceName: DeviceName) => `ManualControl/RequestControlPermission/${deviceName}`,
  },
  ResponseControlPermissionRequest: {
    method: 'post',
    url: (deviceName: DeviceName, userName: string, allowControl: boolean) =>
      `ManualControl/ResponseControlPermissionRequest/${deviceName}/${userName}/${allowControl}`,
  },
};

export type ManualControlCacheItem = {
  ioTHubDeviceName?: string;
  userName?: string;
  /**
   * Only if there is a main operator in general - its just a helper internally
   */
  isMainOperator?: boolean;
  lastAcivityTime?: string;
};

export class ManualControlManager {
  static async GetCurrentMainOperator(deviceName: string) {
    const { method, url } = ManualControlUrls.GetCurrentMainOperator;
    const { data } = await axiosRequest<ManualControlCacheItem>(method, url(deviceName));
    return data;
  }

  static async SetCurrentActivity(deviceName: string) {
    const { method, url } = ManualControlUrls.SetCurrentActivity;
    const { data: username } = await axiosRequest<string>(method, url(deviceName));
    return username;
  }

  static async RemoveCurrentActivity(deviceName: string) {
    const { method, url } = ManualControlUrls.RemoveCurrentActivity;
    await axiosRequest<string>(method, url(deviceName));
  }

  static async PingActivity(deviceName: string) {
    const { method, url } = ManualControlUrls.PingActivity;
    await axiosRequest<string>(method, url(deviceName));
  }

  static async RequestControlPermission(deviceName: string) {
    const { method, url } = ManualControlUrls.RequestControlPermission;
    await axiosRequest<unknown>(method, url(deviceName));
  }

  static async ResponseControlPermissionRequest(
    deviceName: string,
    userName: string,
    allowControl: boolean,
  ) {
    const { method, url } = ManualControlUrls.ResponseControlPermissionRequest;
    await axiosRequest<unknown>(method, url(deviceName, userName, allowControl));
  }
}
